import Image from 'next/image';
import imgProxyLoader from 'helpers/imgProxyLoader';

export default function ProxyFutureImage(props) {
  // eslint-disable-next-line jsx-a11y/alt-text
  return <Image loader={imgProxyLoader} {...props} />;
}
